import React from 'react';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';
import differenceInMilliseconds from 'date-fns/differenceInMilliseconds';

export default class ProgressBar extends Component {
  static propTypes = {
    startedAt: PropTypes.string.isRequired,
    expectedFinishDate: PropTypes.string.isRequired,
  }

  state = {};

  componentDidMount() {
    this.interval = setInterval(() => this.setState({ foo: this.state.foo + 1 }), 100);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const { expectedFinishDate, startedAt } = this.props;
    const percentage = (
      differenceInMilliseconds(new Date(startedAt), new Date()) /
        differenceInMilliseconds(new Date(startedAt), new Date(expectedFinishDate))
    );

    if (percentage > 1) {
      return (
        <div className="ProgressBar ProgressBar--indeterminate">
          <div className="ProgressBar__progress" />
        </div>
      );
    }

    return (
      <div className="ProgressBar">
        <div
          className="ProgressBar__progress"
          style={{ width: `${100 * percentage}%` }}
        />
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./app/components/ProgressBar.jsx